import Model from '@/models/Model.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class GradebookGrade extends Model {
    static entity = 'gradebook_grades';

    static modelName = 'GradebookGrade';

    static fields() {
        return {
            id: this.attr(null),
            gradebook_id: this.attr(null),
            activity_id: this.attr(null),
            user_id: this.attr(null),
            activity_submission_id: this.attr(null),
            points: this.attr(null),
            grading_scheme_id: this.attr(null),
            grading_scheme_criteria_id: this.attr(null),
            automatic: this.attr(null),
            overridden: this.attr(null),
            override_reason: this.attr(null),
            comments: this.attr(null),
            media: this.attr(null),
            user: this.attr(null),
            zero_reason: this.attr(null),
            // Undeclared fields are dropped on insert; the activity grader reads this.
            late_deduction: this.attr(null),

            ...super.fields(),

            activity: this.belongsTo('activities', 'activity_id'),
            gradebook: this.belongsTo('gradebooks', 'gradebook_id'),
            activity_submission: this.belongsTo('activity_submissions', 'activity_submission_id'),
            grading_scheme: this.belongsTo('grading_schemes', 'grading_scheme_id'),
            grading_scheme_criteria: this.belongsTo('grading_scheme_criterias', 'grading_scheme_criteria_id'),
        };
    }

    static queryBuilder() {
        return new QueryBuilder('gradebook-grades');
    }
}
